import { db } from '@/firebase'

export default {
  saveNoticia({ rootState, rootGetters }, not) {
    const negocio = rootState.app.negocioGest;
    const id = not.id;
    delete not.id;
    var p;
    if (id) {
      p = db.collection('negocios').doc(negocio).collection('noticias')
        .doc(id).set(not, { merge: true }).then(() => {
          return id;
        })
    } else {
      not.activo = true;
      not.eliminado = false;
      not.orden = 99;
      p = db.collection('negocios').doc(negocio).collection('noticias')
        .add(not).then((r) => { return r.id })
    }
    return p;
  },
  deleteNoticia({ rootState }, not) {
    const negocio = rootState.app.negocioGest;
    const id = not.id;
    return db.collection('negocios').doc(negocio).collection('noticias')
      .doc(id).delete()
  },
  getNoticias({ rootState, commit }) {
    const negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio).collection('noticias')
      .get()
      .then((snap) => {
        var res = [];

        snap.forEach(e => {
          res.push({
            ...e.data(),
            id: e.id
          })
        });
        commit('setNoticias', res);
      })

  },
  getNoticia({ rootState, commit }, id) {
    const negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio).collection('noticias')
      .doc(id).get()
      .then((n) => {
        if (!n.exists) return Promise.reject("Noticia no existe");
        return {
          ...n.data(),
          id: n.id
        }
      })

  },
  changeActivo({ rootState }, payload) {
    const negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio).collection('noticias')
      .doc(payload.id).get()
      .then((not) => {
        var res = [];
        if (not.exists) {
          var ref = not.ref;
          return ref.set({ activo: payload.activo }, { merge: true })
        } else {
          return Promise.reject("Noticia no encontrada")
        }
      })
  },
  ordenarNoticias({ rootState }, array) {
    let negocio = rootState.app.negocioGest;
    let arrayPromesas = [];
    console.log(array);
    array.forEach(element => {
      arrayPromesas.push(
        db.collection('negocios').doc(negocio)
          .collection('noticias')
          .doc(element.id)
          .set({ orden: element.orden }, { merge: true })
      )
    });
    return Promise.all(arrayPromesas);
  },
}